import { Grid } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useState } from "react";
import { editIntegratedTracking } from "services/data.internal.service";
import { LoadingDialog } from "ui-components/Alert";
import { Success, Error_ } from "ui-components/Alert";
import { FormTitle, SelectFields } from "ui-components/Form";
import { Texts } from "ui-components/Form";
import { Layout } from "ui-components/Layout";

const carriers = [
  "BEST Cargo",
  "City-Link Express",
  "GDEX",
  "Instant Delivery",
  "Instant Delivery (Arrange in 90 mins)",
  "J&T Cargo (>20kg)",
  "Poslaju",
  "Self Collection Locker (SPX Express)",
  "Self Collection Point (SPX Express)",
  "SPX Express (2DD)",
  "SPX Express (Bulky)",
  "SPX Express (East Malaysia)",
  "SPX Express (NDD)",
  "SPX Express (Sea Shipping)",
  "SPX Express (West Malaysia)",
];

function EditIntegratedTracking() {
  const { customerCode } = useCustomerValue();
  const [form, setForm] = useState({ custOrdNbr: "", trackingNumber: "", carrier: null });
  const [alert, setAlert] = useState(null);
  const editMutation = useMutation(editIntegratedTracking, {});
  const onSuccess = (data) => {
    setForm({ custOrdNbr: "", trackingNumber: "", carrier: null });
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const canSubmit =
    Boolean(form.custOrdNbr) && Boolean(form.trackingNumber) && Boolean(form.carrier);
  const onSubmit = () => {
    const req = { customerCode, ...form };
    editMutation.mutate(req, { onSuccess, onError });
  };
  const editStatus = editMutation.status === "loading";
  return (
    <Layout>
      {alert}
      {editStatus && <LoadingDialog />}
      <FormTitle title={"Update Integrated Order Tracking Info"} />
      <Grid sx={{ padding: "10px 0 0 10px" }} container spacing={3}>
        <Grid item xs={12}>
          <Texts
            field={{ name: "custOrdNbr", value: form.custOrdNbr, label: "Cust Order Number" }}
            onChange={(e) => {
              let value = e.target.value.trim();
              const update = { custOrdNbr: value };
              setForm((prev) => ({ ...prev, ...update }));
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Texts
            field={{
              name: "trackingNumber",
              value: form.trackingNumber,
              label: "Tracking Number (split by comma)",
            }}
            onChange={(e) => {
              let value = e.target.value.trim();
              const update = { trackingNumber: value };
              setForm((prev) => ({ ...prev, ...update }));
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectFields
            field={{ name: "carrier", value: form.carrier, label: "Carrier", errors: {} }}
            options={carriers}
            onChange={(e, v) => setForm((prev) => ({ ...prev, carrier: v }))}
          />
        </Grid>
      </Grid>
      <MDBox mt={2} width="100%" display="flex" justifyContent="center">
        <MDButton
          variant="gradient"
          color="info"
          onClick={() => {
            onSubmit();
          }}
          disabled={!canSubmit || editStatus}
        >
          Submit
        </MDButton>
      </MDBox>
    </Layout>
  );
}
export default EditIntegratedTracking;
